import React from 'react';
import { Box, Typography, Button, Card, CardContent, Alert } from '@mui/material';
import { useKeycloak } from '../../providers/KeycloakProvider';

const AccessDenied = () => {
  const { keycloak } = useKeycloak();

  const handleLogout = () => {
    keycloak.logout();
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: '#f5f5f5' }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          mx: 2,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Alert 
            severity="error" 
            sx={{ 
              mb: 3, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              '& .MuiAlert-icon': {
                fontSize: '2rem',
                marginRight: 1
              }
            }}
          >
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', margin: 0 }}>
              Accès refusé
            </Typography>
          </Alert>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'justify' }}>
            Vous n'avez pas les permissions nécessaires pour accéder à cette application. Veuillez contacter votre administrateur.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={handleLogout}
            sx={{ minWidth: 200 }}
          >
            Retour à l'accueil
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessDenied;
